import React from 'react'
import { BaseView, BaseText } from '@/components/base'
import { useTheme } from '@/hooks/useTheme'

interface GoalItemProps {
  emoji: string
  onPress: () => void
  isSelected: boolean
}

export const GoalItem: React.FC<GoalItemProps> = ({
  emoji,
  onPress,
  isSelected,
}) => {
  const theme = useTheme()

  return (
    <BaseView
      align="center"
      justify="center"
      style={{
        width: '100%',
        height: '100%',
        borderRadius: 34,
        backgroundColor: theme.colors.background.cardItemRoot,
        borderWidth: isSelected ? 2 : 0,
        borderColor: isSelected
          ? theme.colors.border.inputTyping
          : 'transparent',
        cursor: 'pointer',
      }}
      onClick={onPress}
    >
      <BaseText style={{ fontSize: 40 }}>{emoji}</BaseText>
    </BaseView>
  )
}
